module.exports = __webpack_public_path__ + "static/img/zjky.dac1eb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/me/salesOrder/imgs/zjky.png
// module id = ICWJ
// module chunks = 2